import { type AdditionalField } from "@/lib/backend/api";

interface AdditionalFieldItemProps {
  field: AdditionalField;
}

export function AdditionalFieldItem({ field }: AdditionalFieldItemProps) {
  return (
    <div className="space-y-2 text-md font-medium">
      <h3 className="font-bold text-txt-primary">{field.title}</h3>
      <p className="whitespace-pre-wrap text-sm text-txt-secondary">{field.description}</p>
    </div>
  );
}
